import { render } from "./TeoPlayer.vue?vue&type=template&id=81331222"
import script from "./TeoPlayer.vue?vue&type=script&lang=js"
export * from "./TeoPlayer.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__